import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {BasePanelPage} from "../BasePanelPage";
import {DonateComponent} from "./components/DonateComponent";
import {MerchantButton} from "../../../../common/MerchantButton";
import {donateMobileState} from "../../../inline-donation/DonateMobileState";
import {Router} from "../../../../../stem-core/src/ui/Router";
import {INLINE_DONATION_URLS} from "../../../PanelConstants";


export class DonatePanel extends BasePanelPage {
    render() {
        return [
            <DonateComponent ref="donateComponent" onChange={() => this.redraw()}/>,
            <MerchantButton label={donateMobileState.getDonateComponentButtonLabel()}
                            disabled={!donateMobileState.isValid()}
                            onClick={() => this.donate()} className={this.styleSheet.button}/>,
        ];
    }

    donate() {
        Router.changeURL(INLINE_DONATION_URLS.card);
    }

    onMount() {
        super.onMount();

        this.redraw(); // This is for the first rendering where the button doesn't have a label.
    }
}
